import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Cupom Service - valida cupons de desconto no Stripe (via BE).
 */

import { authApi } from './authService';

export interface StripeCouponData {
  id: string;
  percent_off?: number | null;
  amount_off?: number | null; // em centavos
  currency?: string | null;
  duration?: 'once' | 'repeating' | 'forever';
  duration_in_months?: number | null;
  valid?: boolean;
}

interface ValidateCouponResponse {
  success: boolean;
  message?: string;
  data?: StripeCouponData;
}

export const cupomService = {
  /**
   * POST /cupom
   * Valida um cupom pelo id. Retorna { success, data } com os dados do
   * cupom no Stripe (percent_off, amount_off, duration...) quando existe.
   */
  validate: async (cupomId: string): Promise<ValidateCouponResponse> => {
    try {
      const response = await authApi.post('/cupom', { cupomId });
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Cupom inválido") };
    }
  },
};

export default cupomService;
